import $api from "../http";
import { ICreateStaffModel, IStaffItem, IUpdateStaffModel } from "../models/Staff";

class StaffServiceClass {
  async getAdminsList(searchValue: string | null) {
    return await $api.get<IStaffItem[]>(`api/users/admin/get-all?searchValue=${searchValue || ""}`);
  }

  async createAdmin(model: ICreateStaffModel) {
    return await $api.post<boolean>("api/users/admin/create", model);
  }

  async updateAdmin(id: string, model: IUpdateStaffModel) {
    return await $api.put<boolean>(`api/users/admin/update/${id}`, model);
  }

  async deleteAdmin(id: string) {
    return await $api.delete<boolean>(`api/users/admin/delete/${id}`);
  }

  async getSupportsList(searchValue: string | null) {
    return await $api.get<IStaffItem[]>(
      `api/users/support/get-all?searchValue=${searchValue || ""}`
    );
  }

  async createSupport(model: ICreateStaffModel) {
    return await $api.post<boolean>("api/users/support/create", model);
  }

  async updateSupport(id: string, model: IUpdateStaffModel) {
    return await $api.put<boolean>(`api/users/support/update/${id}`, model);
  }

  async deleteSupport(id: string) {
    return await $api.delete<boolean>(`api/users/support/delete/${id}`);
  }
}

export const StaffService = new StaffServiceClass();
